import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./icon.module.css";
const Icon = forwardRef(({ children, className, ...otherProps }, ref) => {
    return (_jsx("span", { ...otherProps, ref: ref, className: clsx(styles.icon, className), children: children }));
});
Icon.displayName = "List.Item.Icon";
export { Icon };
